import React from "react";

import TotalUsage from "./TotalUsage";
import UsageViewSkeleton from "./UsageViewSkeleton";

const UsageView = ({ services, status }) => {
  return status.refresh ? (
    <UsageViewSkeleton />
  ) : (
    <TotalUsage data={services} />
  );
};

export default UsageView;
